import { render, staticRenderFns } from "./CreateNewMenu.vue?vue&type=template&id=ef62efc6&"
import script from "./CreateNewMenu.vue?vue&type=script&lang=js&"
export * from "./CreateNewMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports